module.exports = {
  START: 'start',
  STOP: 'stop',
};
